import React from 'react'
import { Col, Row, Icon } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Button from "../../../components/Buttons";
import helper from "../../../helper/helper";

// Components
import Container from "../../../containers/Container";
import Api_tnn from "../../../api/api.tnn";
import Message from "../../../components/Messages";
import { PieChart, Pie, Sector, Cell, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
const compare = (a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}
const style = {
  top: 0,
  left: 350,
  lineHeight: '24px'
};
class BieuDo extends React.Component {
  constructor(props) {
    super(props);
    const { functions } = props;
    this.state = {
      data: [],
      data_cot: []
    }
  }

  componentDidMount() {
    this.GetBCDK_by_QD()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { idGiayPhep } = this.props;
    if (prevProps.idGiayPhep !== idGiayPhep) {
      this.GetBCDK_by_QD()
    }
  }

  GetBCDK_by_QD = () => {
    const { idGiayPhep, apiGetBCDK_by_QD } = this.props;
    apiGetBCDK_by_QD({ token: this.props.user.access_token, thongtinchung_id: idGiayPhep })
      .then(res => {
        if (res && res.length > 0) {
          let data_cot = []
          res.map((item, idx) => {
            let chuaDanhGia = 0
            let vuotChiSo = 0
            let binhThuong = 0
            switch (item.ketQua_DanhGia) {
              case 0:
                chuaDanhGia = 1
                break;
              case 1:
                vuotChiSo = 1
                break;
              case 2:
                binhThuong = 1
                break;
              default:
                break;
            }

            if (data_cot.filter(x => x.name === item.namBaoCao).length === 0) {
              data_cot.push({ name: item.namBaoCao, chuaDanhGia: chuaDanhGia, vuotChiSo: vuotChiSo, binhThuong: binhThuong })
            } else {
              let index = data_cot.findIndex((x) => { return x.name === item.namBaoCao })
              data_cot[index].chuaDanhGia = data_cot[index].chuaDanhGia + chuaDanhGia
              data_cot[index].vuotChiSo = data_cot[index].vuotChiSo + vuotChiSo
              data_cot[index].binhThuong = data_cot[index].binhThuong + binhThuong
            }
          })
          this.setState({
            data: [
              { name: 'Chưa đánh giá', value: res.filter(x => x.ketQua_DanhGia === 0).length },
              { name: 'Vượt chỉ số', value: res.filter(x => x.ketQua_DanhGia === 1).length },
              { name: 'Bình thường', value: res.filter(x => x.ketQua_DanhGia === 2).length },
            ],
            data_cot: data_cot.sort(compare)
          })
        } else {
          this.setState({ data: [] })
        }
      })
      .catch(err => {
        Message.error(err.message)
      })
  };
  downloadFilePdf = () => {
    const input = document.getElementById('cot');
    helper.exportPdf(input, 'landscape', "BieuDo.pdf")
  }
  downloadFilePdf1 = () => {
    const input = document.getElementById('tron');
    helper.exportPdf(input, 'landscape', "BieuDo.pdf")
  }

  renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    );
  };

  render() {
    const { data, data_cot } = this.state
    const COLORS = ['#faad14', '#f5222d', '#52c41a'];

    return (
      <Container>
        {data.length > 0 ?
          <Row type="flex" justify="center" gutter={[24]}>
            <Col md={24} lg={12} className="char-center" id="tron">
              <div>
                <PieChart width={400} height={400} onClick={this.onPieEnter}>
                  <Pie
                    data={data}
                    // cx={300}
                    // cy={300}
                    labelLine={false}
                    label={this.renderCustomizedLabel}
                    outerRadius={150}
                    fill="#8884d8"
                    legendType='circle'
                  >
                    {
                      data.map((entry, index) => <Cell fill={COLORS[index % COLORS.length]} />)
                    }
                  </Pie>
                  <Legend iconSize={10} width={120} height={140} layout='vertical' verticalAlign='middle' wrapperStyle={style} />
                </PieChart>
                <div style={{ textAlign: "center", fontWeight: "bold" }}>Biểu đồ thống kê trạng thái của báo cáo định kỳ </div>
              </div>
            </Col>
            <Col md={24} lg={12} className="char-center" style={{ height: "400px" }}>
              <div style={{width: "100%"}}>
                <ResponsiveContainer height={400} width="90%" id='cot'>
                  <BarChart data={data_cot} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="chuaDanhGia" stackId="a" fill="#faad14" name="Chưa đánh giá" maxBarSize={75} label />
                    <Bar dataKey="vuotChiSo" stackId="a" fill="#f5222d" name="Vượt chỉ số" maxBarSize={75} label />
                    <Bar dataKey="binhThuong" stackId="a" fill="#52c41a" name="Bình thường" maxBarSize={75} label />
                  </BarChart>
                </ResponsiveContainer>
                <div style={{ textAlign: "center", fontWeight: "bold" }}>Biểu đồ thống kê trạng thái của báo cáo định kỳ theo năm </div>
              </div>
            </Col>
          </Row>
          : <div style={{ color: "#cfcdcd", textAlign: "center" }}>Không có dữ liệu báo cáo định kỳ</div>}
          <Row type="flex" style={{paddingTop:20}}>
          <Col span={12} style={{textAlign:"end"}}>
            
              <Button
                type="pdf"

                onClick={() => this.downloadFilePdf1()}
              >
                <Icon type="file-excel" />
                {"Xuất file pdf"}
              </Button>
          
          </Col>
          <Col span={12}style={{textAlign:"end"}}>
            <Button
              type="pdf"

              onClick={this.downloadFilePdf}
            >
              <Icon type="file-excel" />
              {"Xuất file pdf"}
            </Button>
         
          </Col>
        </Row>

      </Container>
    )
  }
}

BieuDo.propTypes = {
  idGiayPhep: PropTypes.string
};


const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(BieuDo)